module.exports = __webpack_public_path__ + "static/media/Mohamed.da6d9754.jpg";